import { HStack } from "@chakra-ui/react"
import { ButtonEditButton } from "./ui"

const ButtonEdit = (props) => {
  const { data, onChange } = props
  const { link, buttonLabel, openInNewTab } = data

  return (
    <HStack justify="center">
      <ButtonEditButton
        buttonLabel={buttonLabel}
        link={link}
        openInNewTab={openInNewTab}
        onChange={onChange}
      />
    </HStack>
  )
}

export default ButtonEdit
